<template>
    <b-overlay :show="loading" rounded="sm">
        <LocalizationProvider :language="kendoLang">
        <IntlProvider :locale="kendoLang">
            <Grid id="blacklist-grid" ref="grid" :data-items="gridData"
                     :resizable="true" :reorderable="true" :sortable="true"  :groupable="false" :selectable="true"
                     :filterable="false" :column-menu="false" 
                    :pageable="true" :group="group" :sort="sort" :filter="filter" :take="take"
                    :skip="skip" :columns="columns" 
                    :selected-field="selectedField" 
                    @pagechange="pageChangeHandler"
                    >
                    
                <GridToolbar>
                    <div class="grid-toolbar">
                        <div class="flex-fill d-flex align-items-center">
                            <div>
                                <b-form-input
                                    type="text"
                                    
                                    v-model="searchWord"
                                    :debounce="500"
                                    :placeholder="$t('lbl_EMPBE_SearchByKeyword')"
                                />
                            </div>

                            <div>
                                <b-button
                                    variant="primary"
                                    @click="onClickRefresh"
                                    class="m-l-20"
                                >
                                    <i class="fa fa-refresh" style="line-height: 1.5" />
                                    {{ this.$t("lbl_EMPBE_Refresh") }}
                                </b-button>
                            </div>
                        </div>
                        <div>
                            <b-button variant="primary" @click="onClickAdd">
                                <i class="fa fa-plus-circle" style="line-height: 1.5" />
                                {{ this.$t("lbl_EMPBE_Add") }}
                            </b-button>
                        </div>
                        

                    </div>
                </GridToolbar>
                <!--Cell template-->
                
                <template v-slot:commandsTemplate="{ props }">
                    <td>
                        <b-button
                            class="m-l-10"
                            variant="danger"
                            size="sm"
                            @click="onClickDeleteRow(props.dataItem)"
                        >
                            {{ $t("lbl_EMPBE_Delete") }}
                        </b-button>
                    </td>

                </template>
                <template v-slot:createTemplate="{props}">
                    <td>
                        {{ props.dataItem.Udate }}<br>
                        {{ props.dataItem.UpdateBy }}
                    </td>
                </template>
                <template v-slot:statusTemplate="{props}">
                    <td>
                        <span :class="`Status ${props.dataItem.Type.replace(/ /g,'')}`">
                            {{ props.dataItem.Type }}
                        </span>
                    </td>
                </template>
                                
                <!--Cell template Ends-->


            </Grid>
        </IntlProvider>
    </LocalizationProvider>
    </b-overlay>

</template>

<script>
import {
  IntlProvider,
  load,
  LocalizationProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { Input } from "@progress/kendo-vue-inputs";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { adminService } from '@/_services/admin.service';
import { process } from "@progress/kendo-data-query";





export default{
    components:{
        Grid, 
        GridToolbar,
        LocalizationProvider,
        IntlProvider,
        KInput : Input,
        DropDownList,
    },
    data(){
        return{
            searchWord:'',
            addEmail:'',
            rawData: [], // rawdata -> mappeddata -> griddata
            loading:true,
            gridData: [],
            mappedData: [],
            //beingBlock:[],
            group: [],
            sort: [],
            filter: null,
            take: 10,
            skip: 0,
            gridPageable: {
                info: true,
                pageSizes: false,
            },
            columns:[
                {
                    field: "VisitorId",
                    title: "VisitorId",
                    width:"100px"
                },
                {
                    field:"LastName",
                    title:this.$t("Lbl_ContactPersonName")
                },
                {
                    field: "CompanyName",
                    title: this.$t("Lbl_CompanyName"), //Add to ../locales/en.json
                    
                },
                {
                    field: "ContactEmail",
                    title: this.$t("lbl_EMP2_Email")
                },
                {
                    field: "ContactCell",
                    title: this.$t("Lbl_TelephoneNumber")
                },
                {
                    field: "Type",
                    title: this.$t("lbl_EMPBE_Type"),
                    cell: 'statusTemplate'
                },
                {
                    title: this.$t('lbl_EMPBE_LastUpdate'),
                    cell: "createTemplate",
                    width: "200px",
                    sortable: false
                },
                {
                    title: this.$t("lbl_EMPBE_Action"),
                    cell: "commandsTemplate",
                    width: "140px",
                    sortable: false
                },  
            ],
            selectedField: "selected",
            dateSortingData:[
                { value: "asc", text: this.$t("lbl_EMP2_Sort_Asc") },
                { value: "desc", text: this.$t("lbl_EMP2_Sort_Dsc") }
            ],
            dateSortingDefault: { value: '', text: this.$t('Lbl_News_SortByDate') },
        }
    },
    mounted() {
        this.init();
        this.user;
    },
    created() {
        this.gridData = this.MapToGrid(this.rawData);
    },
    computed: {
        user() {   
            console.log(this.$store.state.authentication.user)       
            return this.$store.state.authentication.user;
        },
        kendoLang() {
            var langid = localStorage.getItem("currentLangId");
            switch (langid) {
                case "1252":
                return "en-US";
                case "950":
                return "zh-Hant";
                case "936":
                return "zh-Hans";
                default:
                return "zh-Hans";
            }
        },   
    },
    watch: {
        searchWord(val){
            this.take = 10;
            this.skip = 0;
            if(val){
                this.filter = {
                    logic: 'or',
                    filters: [
                        {
                            field:'LastName',
                            operator:'contains',
                            value:val
                        },
                        {
                            field:'CompanyName',
                            operator:'contains',
                            value:val
                        },
                        {
                            field:'ContactEmail',
                            operator:'contains',
                            value:val
                        },
                        {
                            field:'ContactCell',
                            operator:'contains',
                            value:val
                        },
                        {
                            field:'VisitorId',
                            operator:'contains',
                            value:val
                        },
                        {
                           field:'Type',
                           operator:'contains',
                           value:val 
                        }

                        
                    ]
                }
            }else this.filter = null;
            this.gridData = process(this.mappedData,{
                filter:this.filter,
                take:this.take,
                skip:this.skip
            })
        },
    },
    methods:{
        init() {
            // Get Data From server
            this.GetData();  
        },
        GetData(){
            const that = this;
            this.loading = true;
            //Use jwt token to get companyid
            adminService.GetBlacklist().then((res)=>{
                if(res.isSuccessful){
                    that.rawData = res.data;
                    //console.log(that.rawData)
                    that.totalRows = this.rawData.length;

                     // Map Raw data into table
                     this.MapToGrid(that.rawData);
                }
            }).finally(() => {
                that.loading = false;
                
            })
        },
        MapToGrid(rawData){
            
            this.mappedData = rawData.map((x)=>({
                RID: x.rid,
                VisitorId: x.visitorId,
                CompanyName: x.companyName ? x.companyName:"-",
                ContactEmail: x.contactEmail ? x.contactEmail:"-",
                LastName: x.lastName ?  x.lastName:"-",
                ContactCell: x.contactCell ? x.contactCell:"-",
                Type: x.type,
                Udate: x.udate,
                UpdateBy: x.updateBy
            }));
            this.gridData = process(this.mappedData,{
                take: this.take,
                skip: this.skip,
                group: this.group,
                sort: this.sort,
                filter: this.filter
            })

        },
        pageChangeHandler: function (event) {
            this.loader = true;

            console.log(event)
            this.skip = event.page.skip
            this.take = event.page.take
            this.gridData = process(this.mappedData,{
                skip : this.skip,
                take : this.take,
            })

            this.loader = false;
        },
        onClickAdd(){
            let beingBlock = []
            this.$swal({
                text:this.$t('lbl_EMPBE_PleaseInputEmail'),
                input:"email",
                showCancelButton:true,
                inputValidator: (value) => {            
                    if (!value) {
                        return this.$t('lbl_EMPBE_PleaseInputEmail');
                    }
                }
            }).then(result=>{
                if(result.value){//search email if exist in db or not
                    adminService.GetMembershipByEmail(result.value).then((res)=>{
                        if(!res.isSuccessful || res.data.length == 0){
                            this.$swal({
                                text: this.$t('lbl_EMPBE_NoResultFound')
                            })
                            return
                        }
                        //show the searched result
                        beingBlock = res.data.map(x=>({
                            visitorId: x.visitorId,
                            lastName: x.lastName,
                            companyName: x.companyName
                        }))
                        console.log(beingBlock)
                        this.$swal({
                            html:this.createHTML(beingBlock, result.value),
                            showCancelButton:true
                        }).then(_=>{
                            if(_.isConfirmed){
                                //select blocking type: Sourcing form || Inquiry form
                                this.$swal({
                                    html:`
                                            <div style="display: flex; justify-content: center; text-align: left">
                                                <div>
                                                    <h2 style="text-align: center">${this.$t('Lbl_PleaseSelect')}</h2>
                                                    <br>
                                                    <div>
                                                        <input id="sourcing"  type="checkbox"/>
                                                        <label for="sourcing">Sourcing form</label><br>
                                                        <input id="inquiry"  type="checkbox"/>
                                                        <label for="inquiry">Inquiry form</label><br>
                                                        <input id="namecard"  type="checkbox"/>
                                                        <label for="namecard">Name Card</label><br>
                                                    </div>
                                                <div>
                                            </div>`,
                                    showCancelButton:true,
                                    inputValidator: (value) => {
                                            if (!value) {
                                                return this.$t('Lbl_PleaseSelect');
                                            }
                                    },
                                    preConfirm:()=>{
                                        return [
                                            {
                                                value: document.getElementById("sourcing").checked,
                                                name: "Sourcing form"
                                            },
                                            {
                                                value: document.getElementById("inquiry").checked,
                                                name: "Inquiry form"
                                            },
                                            {
                                                value: document.getElementById("namecard").checked,
                                                name: "Name Card"
                                            }
                                        ]
                                    }
                                }).then(res=>{
                                    if(res.value){
                                        //Add those to blacklist
                                        try
                                        {
                                            beingBlock.forEach(x=>{
                                                res.value.forEach(vv => {
                                                    let value = vv.value ? vv.value : false;
                                                    let name = vv.name ? vv.name : "";
                                                    if(value){
                                                        //console.log(x.visitorId, name);
                                                        adminService.AddBlacklist(x.visitorId, name);

                                                    }
                                                })
                                           
                                            })
                                        }
                                        catch(err){
                                            console.log(err)
                                        }
                                        finally{
                                            setTimeout(()=>{
                                                this.Reload()
                                            }, 500)  
                                        } 
                                    }
                                });
                            }
                            
                        })                      
                    })
                    
                }
            })
        },
        createHTML(beingBlock, email){
            let tbody = beingBlock.map(x=>`
                            <tr>
                                <td>${x.visitorId}</td>
                                <td>${x.lastName}</td>
                                <td>${x.companyName}</td>
                                <td>${email}</td>
                            </tr>
                        `).join('');
            return `${beingBlock.length} ${beingBlock.length > 1? "records":"record"} found<br>
                            <div style="text-align: center;">
                                <table style="margin: 0 auto;">
                                    <thead>
                                        <tr>
                                            <th style="padding: 8px">VisitorId</th>
                                            <th style="padding: 8px">Name</th>
                                            <th style="padding: 8px">Company Name</th>
                                            <th style="padding: 8px">Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        ${tbody}
                                    </tbody>
                                </table> 
                            </div>`
        },
        onClickDeleteRow(dataItem){
            const that = this
            this.$swal({
                title:this.$t('lbl_EMPBE_SureToDelete'),
                html:`
                        <b>${this.$t('Lbl_ContactPersonName')}:</b> ${dataItem.LastName}<br>
                        <b>${this.$t('Lbl_CompanyName')}:</b> ${dataItem.CompanyName}<br>
                        <b>${this.$t("lbl_EMP2_Email")}:</b> ${dataItem.ContactEmail}
                      `,
                showCancelButton:true,
            }).then(result=>{
                if(result.isConfirmed){
                    adminService.DeleteBlacklist(dataItem.RID).then(res=>{
                        console.log(res)
                        if(res){
                            that.Reload();
                            that.$swal({
                                text: that.$t('lbl_EMPBE_DeleteSuccess')
                            })
                        }
                        else{
                            that.$swal({
                                text: that.$t('lbl_EMPBE_DeleteFailed')
                            })
                        }
                    });
                }
                
            })
            
        },
        onClickRefresh(){
            this.Reload();
        },
        Reload(){
            this.searchWord=''
            this.filter=null
            this.skip=0
            this.take=10
            this.gridData = this.GetData()
        },

    }    
}
</script>

<style lang="scss">
  @import "../style/grid"; 
</style>
